import React, {useEffect, useState} from 'react';
import {Alert, Col, Row} from 'antd';
import MyEventCard from './../index';
import SectionLayout from './../../../Layout/sectionLayout';
import {
  EventRegistrationStatus,
  EventRegistrationType,
  ToBePaidStatusFilterValue,
  myEventsCategoryOptions,
} from './../../../../../Util/commonUtility';
import {getAllMyEventsCart} from '../../../../../Store/Actions/events';
import useDebouncedCallback from '../../../../../hooks/useDebounce';
import {useDispatch} from 'react-redux';
import CommonAddNewListingWithFilter from '../../../Common_AddNewListing_with_Filter';
import EventTypeFilter from '../../../EventTypeFilter';
import useLocalization from '../../../../../Localization';

const MyEventListingToBePaid = ({formattedEventData, setUserCredit}) => {
  const dispatch = useDispatch();
  const {ApplicationString} = useLocalization();
  const [searchValues, setSearchValues] = useState('');
  const [selectedYearValue, setSelectedYearValue] = useState('');
  const [eventType, setEventType] = useState(EventRegistrationType.regular);
  const [filteredEvents, setFilteredEvents] = useState([]);

  const isCartStatus = (s) =>
    s === EventRegistrationStatus.TO_BE_PAID ||
    s === EventRegistrationStatus.PAYMENT_PROCESSING;

  const filterEvents = (events, type) => {
    return events?.filter((event) => {
      if (type === EventRegistrationType.regular) {
        return event?.attendees?.some((attendee) =>
          isCartStatus(attendee?.status),
        );
      } else if (type === EventRegistrationType.sponsorship) {
        return event?.sponsors?.some((sponsor) =>
          isCartStatus(sponsor?.status),
        );
      } else if (type === 'both') {
        return (
          event?.attendees?.some((attendee) =>
            isCartStatus(attendee?.status),
          ) && event?.sponsors?.some((sponsor) => isCartStatus(sponsor?.status))
        );
      }
      return false;
    });
  };

  // Build 1 or 2 cards per event: Payment Processing card first, then To Be Paid card (event-wise)
  const buildCartCards = (events, type) => {
    if (!events?.length) return [];
    const cards = [];
    events.forEach((event) => {
      const isSponsorship = type === EventRegistrationType.sponsorship;
      const paymentProcessingList = isSponsorship
        ? event?.sponsors?.filter(
            (s) => s?.status === EventRegistrationStatus.PAYMENT_PROCESSING,
          ) || []
        : event?.attendees?.filter(
            (a) => a?.status === EventRegistrationStatus.PAYMENT_PROCESSING,
          ) || [];
      const toBePaidList = isSponsorship
        ? event?.sponsors?.filter(
            (s) => s?.status === EventRegistrationStatus.TO_BE_PAID,
          ) || []
        : event?.attendees?.filter(
            (a) => a?.status === EventRegistrationStatus.TO_BE_PAID,
          ) || [];
      if (paymentProcessingList.length > 0) {
        cards.push({
          key: `${event?.id}-payment_processing`,
          cartStatusType: 'payment_processing',
          event,
          attendees: isSponsorship
            ? event?.attendees || []
            : paymentProcessingList,
          sponsors: isSponsorship
            ? paymentProcessingList
            : event?.sponsors || [],
        });
      }
      if (toBePaidList.length > 0) {
        cards.push({
          key: `${event?.id}-to_be_paid`,
          cartStatusType: 'to_be_paid',
          event,
          attendees: isSponsorship ? event?.attendees || [] : toBePaidList,
          sponsors: isSponsorship ? toBePaidList : event?.sponsors || [],
        });
      }
    });
    return cards;
  };

  const [cartCards, setCartCards] = useState([]);

  useEffect(() => {
    if (formattedEventData) {
      const filtered = filterEvents(formattedEventData, eventType);
      const cards = buildCartCards(filtered, eventType);
      setFilteredEvents(filtered);
      setCartCards(cards);
    } else {
      setFilteredEvents(null);
      setCartCards([]);
    }
  }, [eventType, formattedEventData]);

  const onSearch = () => {
    dispatch(
      getAllMyEventsCart(
        ToBePaidStatusFilterValue,
        setUserCredit,
        searchValues,
      ),
    );
  };

  //2. Search On Change:
  const searchOnChange = useDebouncedCallback((e) => {
    let search = e.target.value;
    if (search) {
      setSearchValues(e.target.value);
    } else {
      setSearchValues('');
    }
  }, 1500);

  useEffect(() => {
    dispatch(
      getAllMyEventsCart(
        ToBePaidStatusFilterValue,
        setUserCredit,
        searchValues,
      ),
    );
  }, [searchValues]);

  // const onViewMore = () => {
  //   setPage((prev) => {
  //     const newPage =
  //       prev + DefaultListingViewMoreCount?.eventsListingViewMoreCount;
  //     dispatch(
  //       getAllMyEventsCart(
  //         ToBePaidStatusFilterValue,
  //         newPage,
  //         setTotalItems,
  //         setUserCredit,
  //         searchValues,
  //         yearValue,
  //       ),
  //     );
  //     return newPage;
  //   });
  // };

  const handleYearFilter = (yearValue) => {
    if (!yearValue) {
      dispatch(
        getAllMyEventsCart(
          ToBePaidStatusFilterValue,
          setUserCredit,
          searchValues,
        ),
      );
      setSelectedYearValue('');
    } else {
      dispatch(
        getAllMyEventsCart(
          ToBePaidStatusFilterValue,
          setUserCredit,
          searchValues,
          yearValue,
        ),
      );
      setSelectedYearValue(yearValue);
    }
  };

  return (
    <React.Fragment>
      <SectionLayout>
        <Row gutter={[0, 32]}>
          <Col span={24}>
            <CommonAddNewListingWithFilter
              selectedYearValue={selectedYearValue}
              addNew={false}
              usedForMyEvents={false}
              usedForMyEventsCart={true}
              year
              search
              status={false}
              registrtion_filter={
                <EventTypeFilter setEventType={setEventType} />
              }
              categoryList={myEventsCategoryOptions}
              searchOnChange={searchOnChange}
              onSearch={onSearch}
              handleYearFilter={handleYearFilter}
              placeHolder={
                ApplicationString['myEventListingToBePaid.placeHolder']
              }
            />
          </Col>
          <Col span={24}>
            <div className='event2-listing-cards'>
              {cartCards?.length > 0 ? (
                cartCards?.map((card) => {
                  const event = card.event;
                  const receiptDataForCard = {
                    ...event,
                    attendees: card.attendees,
                    sponsors: card.sponsors,
                  };
                  const toBePaidSponsor = card.sponsors || [];
                  return (
                    <MyEventCard
                      paid={false}
                      key={card.key}
                      eventRegistrationType={eventType}
                      eventId={event?.id}
                      attendees={card.attendees}
                      chapter={event?.chapter}
                      date={event?.date}
                      eventName={event?.eventName}
                      eventLocalChapterId={event?.eventLocalChapterId}
                      eventType={event?.eventType}
                      eventInfo={event?.eventInfo}
                      sponsorshipAvailable={event?.sponsorshipAvailable}
                      registration_status={event?.registration_status}
                      status={event?.status}
                      receiptData={receiptDataForCard}
                      usedForMyEvents={true}
                      usedForMyEventsCart={true}
                      sponsors={card.sponsors}
                      eventStartDate={
                        event?.event_start_date || event?.dateObject?.event_start_date
                      }
                      refundLastDate={event?.refund_last_date}
                      toBePaidSponsor={toBePaidSponsor}
                      dateObject={event?.dateObject}
                    />
                  );
                })
              ) : (
                <Alert
                  message={
                    ApplicationString[
                      'myEventListingToBePaid.noEventsAvailable'
                    ]
                  }
                  className='no-jobs-alert'
                  type='info'
                  showIcon
                />
              )}
            </div>
          </Col>
          {/* <Col span={24}>
            {totalItems > formattedEventData?.length && (
              <div className='view-more-container'>
                <Button
                  className='view-more-button'
                  id='myProfileMyEvents-viewMore-button'
                  onClick={onViewMore}>
                  <span className='view-more-text'>View More Events</span>
                  <DownArrowSvg />
                </Button>
              </div>
            )}
          </Col> */}
        </Row>
      </SectionLayout>
    </React.Fragment>
  );
};

export default MyEventListingToBePaid;
